export default {"src":"/_next/static/image/public/images/ic_profile_selected.1f1c8f87c12866885913f6928916c2b5.svg","height":28,"width":28};